import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.header`
  width: 100%;
  background-color: #fff;
  padding: 20px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
`;

export const Logo = styled(Link)`
  width: 120px;
  height: auto;
  
  img {
    width: 100%;
    height: auto;
  }
`;

export const ContentLinks = styled.nav`
  
  display: flex;
  flex-direction: row; 
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  a {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 15px;

    margin-left: 20px;
    text-decoration: none;
    color: #333;
    font-weight: 500;

    &.active{
      background-color: ${({theme}) => theme.colors.colorButton};
      border-radius: 4px;
      color: #fff;
    }

    &:hover {
      background-color: ${({theme}) => theme.colors.colorButton};
      border-radius: 4px;
      color: #fff;
    }
  }
`;

export const UserArea = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    font-weight: bold;
  }

  .email {
    font-size: 12px;
    opacity: 0.7;
  }
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;

  &:hover {
    color: #ff4d4d;
  }
`;